import { format_routes } from '@/utils/tools';
import { lazy } from 'react';

const CompanyIndex = lazy(() => import('../pages/company/index/index'));
const CompanyInfo = lazy(() => import('../pages/company/info/index'));
const BankAccount = lazy(() => import('../pages/company/bank/index'));
const Invoice = lazy(() => import('../pages/company/​invoicing/index'));
const CompanyDetail = lazy(() => import('../pages/company/detail/index'));
const CompanyAddress = lazy(() => import('../pages/company/address/index'));
const CompanyDelivery = lazy(() => import('../pages/company/delivery/index'));
const CompanyAptitude = lazy(() => import('../pages/company/aptitude/index'));
const CategoryQualification = lazy(() => import('../pages/company/category​/index'));
const StaffIndex = lazy(() => import('../pages/staff/index'));
const RoleIndex = lazy(() => import('../pages/role/index'));
const StaffExamine = lazy(() => import('../pages/staff/examine/index'));
const StaffLink = lazy(() => import('../pages/staff/link/index'));
const ContractIndex = lazy(() => import('../pages/company/contract/index/index'));
const ContractDetail = lazy(() => import('../pages/company/contract/detail'));
const ContractPerformance = lazy(() => import('../pages/company/performance/index'));
const ContractPerformanceDetail = lazy(() => import('../pages/company/performance/detail'));

export const companyRouter = [
  {
    path: '/company',
    element: <CompanyIndex />,
    key: 'companyManagement',
    label: 'Company Management', //公司管理,
    children: [
      {
        path: '/company/info',
        element: <CompanyInfo />,
        key: 'companyInfo',
        parentKey: 'companyManagement',
        label: 'Company Basic Information', //公司基本信息
      },
      {
        path: '/company/bank',
        element: <BankAccount />,
        key: 'companyBankAccount',
        parentKey: 'companyManagement',
        label: 'Bank Account Information', //银行账户信息
        // hidden: true,
      },
      {
        path: '/company/detail',
        element: <CompanyDetail />,
        key: 'companyDetail',
        parentKey: 'companyManagement',
        label: 'Company Detail Information', //公司详情信息
      },
      {
        path: '/company/invoice',
        element: <Invoice />,
        key: 'companyInvoice',
        parentKey: 'companyManagement',
        label: 'Invoice Information', //公司开票信息
        // hidden: true,
      },
      {
        path: '/company/address',
        element: <CompanyAddress />,
        key: 'companyAddress',
        parentKey: 'companyManagement',
        label: 'Company Address Management', // '公司地址管理',
      },
      {
        path: '/company/delivery',
        element: <CompanyDelivery />,
        key: 'companyDelivery',
        parentKey: 'companyManagement',
        label: 'Company Delivery Management', //'公司配送管理',
      },
      {
        path: '/company/aptitude',
        element: <CompanyAptitude />,
        key: 'companyAptitude',
        parentKey: 'companyManagement',
        label: 'Company License Management', // '公司资质管理',
      },
      {
        path: '/company/category',
        element: <CategoryQualification />,
        key: 'companyCategoryQualification',
        parentKey: 'companyManagement',
        label: 'Category Qualification Information', // '品种资质信息',
      },
    ],
  },
  {
    path: '/company',
    element: <CompanyIndex />,
    key: 'staffManagement',
    label: 'User Account', //员工账号
    children: [
      {
        path: '/company/staff',
        element: <StaffIndex />,
        key: 'staffIndex',
        parentKey: 'staffManagement',
        label: 'Account Management', // '员工账号管理',
      },
      {
        path: '/company/role',
        element: <RoleIndex />,
        key: 'RoleIndex',
        parentKey: 'staffManagement',
        label: 'User Role Management', // '员工角色管理',
      },
      {
        path: '/company/staff/examine',
        element: <StaffExamine />,
        key: 'accountJoinExamine',
        parentKey: 'staffManagement',
        hidden: true,
        label: 'Review account association applications', // '账号关联申请审核',
      },
      {
        path: '/company/staff/link',
        element: <StaffLink />,
        key: 'staffLink',
        parentKey: 'staffManagement',
        hidden: true,
        label: 'Link Account', // '账号关联申请审核',
      },
    ]
  },
  {
    path: '/company',
    element: <CompanyIndex />,
    key: 'contractManagement',
    label: 'Contract Management', //合同管理
    children: [
      {
        path: '/company/contract',
        element: <ContractIndex />,
        key: 'contractManagementMain',
        parentKey: 'contractManagement',
        label: 'Contract Management', // '合同管理',
      },
      {
        path: '/company/contract/detail/:contract_no/:tab_key?',
        element: <ContractDetail />,
        key: 'detailContractManagement',
        hidden: true,
      },
      {
        path: '/company/contract_performance',
        element: <ContractPerformance />,
        key: 'contractPerformance',
        parentKey: 'contractManagement',
        label: 'Contract Performance', // '合同履约',
      },
      {
        path: '/company/contract_performance/detail',
        element: <ContractPerformanceDetail />,
        key: 'ContractPerformanceDetail',
        parentKey: 'contractManagement',
        label: 'Contract Performance', // '合同履约详情',
        hidden: true,
      }
    ]
  },
];

export const format_company_router_routes = format_routes(companyRouter);